// extracted by mini-css-extract-plugin
export var collapsedSummary = "_lu-0";